import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import ar from 'vee-validate/dist/locale/ar.json';
import * as rules from 'vee-validate/dist/rules';
import axios from 'axios'



// var localurl = "http://ccme-backend.test/api/";

var prodUrl = "https://cp.ccme.ly/api/";

var apiUrl = prodUrl;

window.axios = axios

axios.defaults.headers.post["Content-Type"] = "application/json";
window.axios.defaults.baseURL = apiUrl;
window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});


extend('above18', {
  validate (value) {
    return {
      valid: ['', null, undefined].indexOf(value) === -1
    };
  },
  computesRequired: true
});


localize('ar', ar);
const regexMessageAr = "يجب ان يحتوى على حروف عربية فقط";

localize({
  ar: {
    names: {
      nid: 'الرقم الوطني',
      firstName: 'الاسم الرباعي',
      secondName: 'اسم الاب',
      thirdName: 'اسم الجد',
      lastName: 'اللقب',
      familyBookid: 'تاريخ الميلاد',
      mobile1: 'الهاتف',
      mobile2: 'الهاتف الثامي',
      residence: 'مكان الاقامة',
      otherresidence :'مكان الاقامة',
      municipality: 'البلدية',
      electionCenterNo: 'مركز الاقتراع',
    }
    ,
    fields: {
      firstName: {
        regex: "اسم الاول " + regexMessageAr
      },
      secondName: {
        regex: "اسم الأب " + regexMessageAr
      },
      thirdName: {
        regex: "اسم الجد " + regexMessageAr
      },
      lastName: {
        regex: "اللقب " + regexMessageAr
      },
      nid: {
        max:
        "الحقل الرقم الوطني يجب ان يحتوي على 12 رقم على الأكثر.",
        regex: "الرقم الوطني يجب ان يبدا ب 1 او 2 "
      },
      mobile1: {
        regex: "رقم الهاتف يجب ان يبدا ب(09) ويليه ثمان ارقام "
      },
      mobile2: {
        regex: "رقم الهاتف يجب ان يبدا ب(09) ويليه ثمان ارقام "
      },
    }
  }
});

// Install components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.config.productionTip = false;

import './assets/styles/index.css';

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
